module.exports = __webpack_public_path__ + "img/no-data.4e637ecd.gif";